<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
    <a class="navbar-brand" href="#">Games 4 - 2</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li v-for="(option, key) in options" class="nav-item dropdown interactive">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownTeetotum" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ key }}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownTeetotum">
            <a v-for="(suboption, key) in option" class="dropdown-item" @click="navigate(suboption)">{{ suboption.name }}</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "app-navigation",
    props: {
      options: {type: Object, requite: true}
    },
    methods: {
      navigate(page) {
        this.$emit('navigate', page);
      }
    }
  }
</script>

<style scoped>
  .interactive {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/app-navigation.vue